/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ next_billing_date: NonNullable<unknown> }} Subscribed_Card_Next_BillingInputs */

const en_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next renewal date: ${i?.next_billing_date}`)
};

const ar_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تاريخ التجديد التالي: ${i?.next_billing_date}`)
};

const de_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächstes Verlängerungsdatum: ${i?.next_billing_date}`)
};

const es_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próxima fecha de renovación: ${i?.next_billing_date}`)
};

const fr_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochaine date de renouvellement: ${i?.next_billing_date}`)
};

const it_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossima data di rinnovo: ${i?.next_billing_date}`)
};

const ja_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`次回更新日：${i?.next_billing_date}`)
};

const ko_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`다음 갱신일: ${i?.next_billing_date}`)
};

const pt_br_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Data da próxima renovação: ${i?.next_billing_date}`)
};

const ru_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Дата следующего продления: ${i?.next_billing_date}`)
};

const th_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`วันต่ออายุครั้งถัดไป: ${i?.next_billing_date}`)
};

const tr_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bir sonraki yenileme tarihi: ${i?.next_billing_date}`)
};

const zh_cn_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下次续费日：${i?.next_billing_date}`)
};

const zh_tw_subscribed_card_next_billing = /** @type {(inputs: Subscribed_Card_Next_BillingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`下次續訂日：${i?.next_billing_date}`)
};

/**
* | output |
* | --- |
* | "Next renewal date: {next_billing_date}" |
*
* @param {Subscribed_Card_Next_BillingInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscribed_card_next_billing = /** @type {((inputs: Subscribed_Card_Next_BillingInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscribed_Card_Next_BillingInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscribed_card_next_billing(inputs)
	if (locale === "ar") return ar_subscribed_card_next_billing(inputs)
	if (locale === "de") return de_subscribed_card_next_billing(inputs)
	if (locale === "es") return es_subscribed_card_next_billing(inputs)
	if (locale === "fr") return fr_subscribed_card_next_billing(inputs)
	if (locale === "it") return it_subscribed_card_next_billing(inputs)
	if (locale === "ja") return ja_subscribed_card_next_billing(inputs)
	if (locale === "ko") return ko_subscribed_card_next_billing(inputs)
	if (locale === "pt_br") return pt_br_subscribed_card_next_billing(inputs)
	if (locale === "ru") return ru_subscribed_card_next_billing(inputs)
	if (locale === "th") return th_subscribed_card_next_billing(inputs)
	if (locale === "tr") return tr_subscribed_card_next_billing(inputs)
	if (locale === "zh_cn") return zh_cn_subscribed_card_next_billing(inputs)
	return zh_tw_subscribed_card_next_billing(inputs)
});